// @flow
export { default } from './BannerCard';



// WEBPACK FOOTER //
// ./src/components/common/BannerCard/index.js